import React from 'react'
import { DeleteOutlined, Description, CheckCircle, Clear } from '@mui/icons-material'
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, TextField, IconButton } from '@mui/material'
import dashboardServices from '../../../../services/hoa-dashboard-api-service'
import { LoadingButton } from '@mui/lab'


const SourceIDVerificationCard = ({
    index, item, loading, setLoading, handleSourceFile, handleDeleteCard, parentIndex, parentKey
}: any) => {

    const handleVerifySourceId = async () => {
        if(item.sourceId && item.sourceIdType) {
            setLoading(true);
            const result:any = await dashboardServices.getFilesBySourceId(item.sourceId, item.sourceIdType);
            if(result.status === 200 && result.data.length > 0) {
                handleSourceFile({target: {name: 'files', value: result.data}}, index, parentIndex, parentKey);
            } else {
                handleSourceFile({target: {name: 'files', value: result.data}}, index, parentIndex, parentKey);
            }
            setLoading(false);
        }
    }

  return (
    <Stack sx={{p: 2, mt: 3, backgroundColor: '#FAFAFA', borderRadius: '8px', gap: '12px', border: '1px solid #E8E8E8'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <p>{index+1}</p>
            <IconButton onClick={()=>handleDeleteCard(index, parentIndex, parentKey)}>
                <DeleteOutlined />
            </IconButton>
        </div>
        <div className="sub-title-text-2" style={{margin:"12px 0px"}}>Source Type</div>
        <FormControl>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="sourceIdType"
                value={item.sourceIdType}
                onChange={(e) => handleSourceFile(e, index, parentIndex, parentKey)}
            >
                <FormControlLabel value="mail" disabled={item.isVerified} control={<Radio />} label="Mail" />
                <FormControlLabel value="email" disabled={item.isVerified} control={<Radio />} label="Email" />
                <FormControlLabel value="document" disabled={item.isVerified} control={<Radio />} label="Document" />
            </RadioGroup>
        </FormControl>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px'}}>
            <TextField 
                label='Source ID'
                variant='standard'
                size='small'
                disabled={item.isVerified}
                sx={{width: '100%'}}
                name='sourceId'
                value={item.sourceId}
                onChange={(e) => handleSourceFile(e, index, parentIndex, parentKey)}
            />
            <LoadingButton
                size="small"
                onClick={handleVerifySourceId}
                loading={loading}
                loadingPosition="end"
                variant="contained"
                disabled={item.isVerified}
                >
                Verify
            </LoadingButton>
        </div>
        {
            item.isVerified &&
                <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '4px', borderBottom: '1px solid #E8E8E8', paddingBottom: '12px'}}>
                    <CheckCircle sx={{color: '#4CAF50'}}/>
                    <p>Verified</p>
                </div>
        
        }
        {
            !item.isVerified && item?.files?.length == 0 &&
            <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '4px', borderBottom: '1px solid #E8E8E8', paddingBottom: '12px'}}>
                <Clear sx={{color: '#4CAF50'}}/>
                <p>{item.sourceIdType} is not verified.</p>
            </div>
        }

        {
            item.files && item.files.length > 0 ? (
                item.files.map((file: any, index: number) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                    >
                        <Description />
                        <p>{file}</p>
                    </div>
                ))
            ) : (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '12px',
                    }}
                >
                    <Description />
                    <p>No files linked yet.</p>
                </div>
            )
        }


    </Stack>
  )
}

export default SourceIDVerificationCard